import z from "zod";

export const PaginationSchema = z.object({
  page: z.number().int().min(1).optional(),
  perPage: z.number().int().min(1).max(100).optional(),
});

export const PaginationResponseSchema = <T extends z.ZodSchema>(schema: T) =>
  z.object({
    items: z.array(schema),

    currentPage: z.number().int().positive(),
    perPage: z.number().int().positive(),

    hasNextPage: z.boolean(),
    hasPreviousPage: z.boolean(),

    nextPage: z.number().int().positive().optional(),
    previousPage: z.number().int().positive().optional(),

    totalItems: z.number().int().nonnegative(),
    totalPageNumbers: z.number().int().nonnegative(),
    lastPageNumber: z.number().int().nonnegative(),

    startItem: z.number().int().nonnegative(),
    endItem: z.number().int().nonnegative(),

    itemsOnPage: z.number().int().nonnegative(),
    isEmpty: z.boolean(),
  });

export type PaginationRequest = z.infer<typeof PaginationSchema>;

export type PaginationResponse<T> = {
  items: T[];
  currentPage: number;
  perPage: number;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
  nextPage: number | undefined;
  previousPage: number | undefined;
  totalItems: number;
  totalPageNumbers: number;
  lastPageNumber: number;
  startItem: number;
  endItem: number;
  itemsOnPage: number;
  isEmpty: boolean;
};
